// import logo from './logo.svg';
import './App.css';
// import React from "react";

import React, { Component } from 'react'
import Navbar from './components/Navbar';
import News from './components/News';
// import PropTypes from 'prop-types'
// import { useState } from "react";
import LoadingBar from "react-top-loading-bar";

import {
  BrowserRouter as Router,
  // Switch,
  Routes,
  Route
} from 'react-router-dom';


export default class App extends Component {
  pageSize = 6;
  apiKey = process.env.REACT_APP_NEWS_API_CODE

  state = {
    progress: 20
  }
  setProgress = (progress) => {
    this.setState({ progress: progress })
  }
  render() {
    return (
      <div>
        <Router>

          <Navbar />
          {/* <News setProgress= {this.setProgress  }  pageSize={this.pageSize} country="us" category="sports" /> */}
          <LoadingBar
            height={3}
            color="#f11946"
            progress={this.state.progress}

          />
          <Routes>

            <Route path="/home" element={<News setProgress= {this.setProgress  }  key="home" pageSize={this.pageSize} country="us" category="home" />} />
            <Route path="/general" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="general" pageSize={this.pageSize} country="us" category="general" />} />
            <Route path="/business" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="business" pageSize={this.pageSize} country="us" category="business" />} />
            <Route path="/entertainment" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="entertainment" pageSize={this.pageSize} country="us" category="entertainment" />} />
            <Route path="/health" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="health" pageSize={this.pageSize} country="us" category="health" />} />
            <Route path="/science" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="science" pageSize={this.pageSize} country="us" category="science" />} />
            <Route path="/sports" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="sports" pageSize={this.pageSize} country="us" category="sports" />} />
            <Route path="/technology" element={<News setProgress={this.setProgress} apiKey={this.apiKey} key="technology" pageSize={this.pageSize} country="us" category="technology" />} />
          </Routes>

        </Router>
      </div>
    )
  }
}
